import { render, staticRenderFns } from "./cambiarCategoria.vue?vue&type=template&id=50d0f2cc"
import script from "./cambiarCategoria.vue?vue&type=script&lang=js"
export * from "./cambiarCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports